import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        items: [], // { product, quantity, color, size }
    },
    reducers: {
        // Thêm sản phẩm vào giỏ hàng
        addToCart: (state, action) => {
            const { product, quantity, color, size } = action.payload;
            const existing = state.items.find(item => {
                // Kiểm tra với biến thể nếu có, nếu không chỉ so sánh product.id
                if (item.product.id === product.id) {
                    if (item.color && color && item.color.name === color.name && item.size === size) {
                        return true;  // Nếu có color và size, kiểm tra chúng
                    }
                    if (!item.color && !color) {
                        return true;  // Nếu không có biến thể nào, so sánh chỉ với product.id
                    }
                }
                return false;
            });
            if (existing) {
                // Nếu sản phẩm đã có trong giỏ, cộng thêm số lượng
                existing.quantity += quantity;
            } else {
                // Nếu chưa có, thêm sản phẩm mới vào giỏ
                state.items.push({ product, quantity, color, size });
            }
        },

        // Cập nhật số lượng của sản phẩm trong giỏ
        updateQuantity: (state, action) => {
            const { item, quantity } = action.payload;
            const target = state.items.find(
                (i) => {
                    // Kiểm tra nếu item có color và size thì so sánh với cả color và size
                    if (i.product.id === item.product.id) {
                        if (i.color && item.color && i.color.name === item.color.name && i.size === item.size) {
                            return true;
                        }
                        // Nếu không có color và size thì chỉ so sánh theo product.id
                        if (!i.color && !item.color) {
                            return true;
                        }
                    }
                    return false;
                }
            );
            if (target) {
                // Cập nhật số lượng của sản phẩm
                target.quantity = quantity;
            }
        },

        // Xóa sản phẩm khỏi giỏ hàng
        removeFromCart: (state, action) => {
            const { product, color, size } = action.payload;
            state.items = state.items.filter(
                (i) => {
                    if (i.product.id === product.id) {
                        if (i.color && color && i.color.name === color.name && i.size === size) {
                            return false; // Nếu có color và size, xóa sản phẩm này
                        }
                        if (!i.color && !color) {
                            return false; // Nếu không có biến thể nào, chỉ xóa sản phẩm theo product.id
                        }
                    }
                    return true;
                }
            );
        },
    }
});

export const { addToCart, updateQuantity, removeFromCart } = cartSlice.actions;
export default cartSlice;
